// extracted by mini-css-extract-plugin
module.exports = {"pageHeadingTitle":"bonus-screen_pageHeadingTitle__2WTrj"};